import ScrollMilestones from './ScrollMilestones'

export default ScrollMilestones
